import t, { createGlobalStyle as o } from "styled-components";
import e from "../../utils/colors.js";
import { Wrapper as r } from "../Input/styled.js";
const u = o`
    :root {
        --duet-font: 'VIC';
        --duet-font-bold: 'VIC';
        --duet-color-surface: white;
        --duet-color-text: ${e.blueGrey};
        --duet-z-index: 3;
        --duet-radius: 2px;
        --duet-color-overlay: rgba(0, 0, 0, 0.58);
        --duet-color-text-active: white;
        --duet-color-primary: ${e.orange};
        --duet-color-border: ${e.blueGrey};
    }

    // Note - added specificity here to ensure values override defaults
    duet-date-picker {
      .duet-date__mobile-heading {
          font-weight: 600;
      }

      .duet-date__input:focus {
          box-shadow: none;
      }

      .duet-date__dialog {
          --duet-color-primary: ${e.blueGrey};
      }

      .duet-date__input {
          padding: 12px 60px 12px 14px;
          visibility: hidden;
      }

      button.duet-date__toggle:disabled {
        cursor: not-allowed;
      }
    }
`, l = t(r)`
  align-items: stretch;
`, p = t.div`
  position: relative;

  > input {
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 34px);
    z-index: 1;
    margin: 0;

    &:focus {
      background: white;
    }
  }
`;
export {
  u as DatePickerOverrides,
  l as FieldWrapper,
  p as InputWrapper
};
